import { Tabs } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FileLimitationEnum } from '../../../enums/FileLimitationEnum';
import { isLockedPasswordFolder } from '../../../lib/fileActions';
import type File from '../../../interfaces/File';
import { useAppStore } from '../../../store/store';
import { hasFileLimitation } from '../../../utils/utils';
import TruncatedTooltip from '../../Common/TruncatedTooltip';
import FileDetailActivitiesTab from '../FileDetailActivitiesTab';
import FileAntivirusStatusIcon from '../FileAntivirusStatusIcon';
import FileDetailTab from '../FileDetailTab';

interface FileDetailProps {
  file: File;
}

const FileDetail: React.FC<FileDetailProps> = ({ file }) => {
  const { t } = useTranslation();
  const getFilePasswordSession = useAppStore((s) => s.getFilePasswordSession);

  const isLockedFolder = isLockedPasswordFolder(file, getFilePasswordSession);

  return (
    <div className="file-detail-side relative flex h-full flex-col px-2">
      <div className="flex max-w-full shrink-0 items-center gap-2">
        <h2 className="max-w-72 truncate text-xl font-medium">
          <TruncatedTooltip>{file.fileName}</TruncatedTooltip>
        </h2>
        <FileAntivirusStatusIcon file={file} />
      </div>
      {isLockedFolder ? (
        <p className="text-gray-dark mt-4 text-sm">{t('common.unlockFolderToViewDetails')}</p>
      ) : (
        <Tabs
          defaultActiveKey="1"
          centered
          className="file-detail-side h-full overflow-y-auto"
          items={[
            {
              key: '1',
              label: t('common.details'),
              children: <FileDetailTab file={file} />,
            },
            {
              disabled: hasFileLimitation(
                file.fileLimitations,
                FileLimitationEnum.DenyFileFileActivities,
              ),
              key: '2',
              label: t('common.activities'),
              children: <FileDetailActivitiesTab file={file} />,
            },
          ]}
        />
      )}
    </div>
  );
};

export default FileDetail;
